module.exports = __webpack_public_path__ + "static/media/allowed-risk-status.343c5b23.svg";